import { Component } from '@angular/core';
import { NgxUiLoaderService, SPINNER } from 'ngx-ui-loader';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'NeOffice';
  spinnerType = SPINNER.circle;
  
  constructor(private ngxService: NgxUiLoaderService) { }
 
  ngOnInit() {
    // this.ngxService.start();
    setTimeout(() => {
      this.ngxService.stop();
    }, 2000);
    // this.ngxService.startBackground('do-background-things');
    // this.ngxService.stopBackground('do-background-things');
  }
}
